import { I18n } from 'i18n-js';
import en from 'i18n-js/json/en.json';
import translations from '../../translations.rs.json';

const i18n = new I18n();

i18n.store(en);
i18n.store(translations);
i18n.defaultLocale = 'en'
i18n.enableFallback = true;
i18n.locale = document.documentElement.lang;

export const t = i18n.t.bind(i18n);
export const l = i18n.l.bind(i18n);
export const numberToCurrency = i18n.numberToCurrency.bind(i18n);
export const numberToPercentage = i18n.numberToPercentage.bind(i18n);
export const numberToDelimited = i18n.numberToDelimited.bind(i18n);
export const numberToRounded = i18n.numberToRounded.bind(i18n);
export const numberToHumanSize = i18n.numberToHumanSize.bind(i18n);
export const numberToHuman = i18n.numberToHuman.bind(i18n);
export const toTime = i18n.toTime.bind(i18n);
export const strftime = i18n.strftime.bind(i18n);
export const timeAgoInWords = i18n.timeAgoInWords.bind(i18n);
export const toSentence = i18n.toSentence.bind(i18n);

export default i18n;
